import nodeViewDecorator from "./nodeViewDecorator.js";
import { TEXT_COLOR_TYPE, TEXT_HIGHLIGHT_TYPE } from "./types.js";
const pluginTextColor = (config = {}) => {
  return {
    config,
    type: TEXT_COLOR_TYPE,
    nodeViewDecorators: [nodeViewDecorator]
  };
};
const pluginTextHighlight = (config = {}) => {
  return {
    config,
    type: TEXT_HIGHLIGHT_TYPE
  };
};
export {
  pluginTextColor,
  pluginTextHighlight
};
//# sourceMappingURL=viewer.js.map
